import React, { useEffect } from 'react'
import "../scss/solution.scss"
import { Container } from 'react-bootstrap'
import SolutionProduct from '../components/SolutionProduct'
import CyberSecurity from '../components/CyberSecurity'
import Digital from '../components/Digital'
import Telecom from '../components/Telecom'
import Workforce from '../components/Workforce'
import DigitalCommerce from '../components/DigitalCommerce'
import BrandExperience from '../components/BrandExperience'
import OmniChannel from '../components/OmniChannel'

const Solution = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0, 
      behavior: 'instant'
    });
  }, [])

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100); // delay agar komponen sudah render
      }
    }
  }, []);

  return(
    <div className='solution-wrap'>
      <Container className='pt-5 pb-5' id='solution-product'>
        <SolutionProduct />
      </Container>
      <Container className='pt-5 pb-5' id='cyber-security'>
        <CyberSecurity />
      </Container>
      <Container className='pt-5 pb-5' id='digital-infrastructure'>
        <Digital />
      </Container>
      <Container className='pt-5 pb-5' id='telecom'>
        <Telecom />
      </Container>
      <Container className='pt-5 pb-5' id='workforce'>
        <Workforce />
      </Container>
      <Container className='pt-5 pb-5' id='digital-commerce'>
        <DigitalCommerce /> 
      </Container>
      <Container className='pt-5 pb-5'  id='brand-experience'>
        <BrandExperience /> 
      </Container>
      <Container className='pt-5 pb-5' id='omni-channel'>
        <OmniChannel /> 
      </Container>
    </div>
  )
}

export default Solution